import { RootState } from '@atredux/store'
import type { StoreDetails } from '@api/userAndStoreContext'
import { NO_CURRENT_STORE } from '@src/constants'

export const getCurrentDomain = (state: RootState): string => state.store._currentDomain
export const getCurrentRegion = (state: RootState): string => state.store._currentRegion
export const getCurrentDomainAndRegion = (state: RootState): string => state.store._currentDomainAndRegion
export const getCurrentCountryCode = (state: RootState): string => state.store._currentCountryCode
export const getStoreId = (state: RootState): string => state.store._currentStore
export const getSelectedStoreId = (state: RootState): string => state.store._selectedStore
export const getStoreInfo = (state: RootState): any => state.store._currentStoreInfo
export const getStoreList = (state: RootState): StoreDetails[] => state.store._storeList
export const isStoreListLoaded = (state: RootState): boolean => state.store._storeListLoaded
export const getStoreScanStatus = (state: RootState, storeId: string): boolean =>
    state.store._storeScanStatus[storeId] || false
export const isConfigured = (state: RootState) => (
    !!state.store._currentDomain &&
    !!state.store._currentDomainAndRegion
)
export const getStoresMatch = (state: RootState): boolean =>
    !state.store._selectedStore || state.store._selectedStore === state.store._currentStore

export const getEffectiveStoreId = (state: RootState): string | undefined => {
    const currentStoreId = state.store._currentStore
    const selectedStoreId = state.store._selectedStore
    return (currentStoreId && currentStoreId !== NO_CURRENT_STORE)
        ? currentStoreId
        : selectedStoreId
}

/**
 * Resolves a store ID for the notification API: currentStore → selectedStore → first store in list.
 * The storeList[0] fallback covers admins/managers who dismiss the store selector without choosing —
 * the API needs a primary store ID to fetch from. This does NOT determine the "Current Store" tab
 * in NotificationsPage; that uses the scanned store ID separately.
 */
export const getNotificationStoreId = (state: RootState): string | undefined => {
    const effectiveId = getEffectiveStoreId(state)
    if (effectiveId) return effectiveId
    const storeList = state.store._storeList
    return storeList.length > 0 ? storeList[0].storeId : undefined
}
